import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeedbackContent } from '../../actions/FooterActions';
import delay from 'lodash/delay';
import PropTypes from 'prop-types';
import FeedbackAEM from '../../../modules/feedbackAEM/FeedbackAEM';
import ChatComponent from '../../../modules/clicktochat/clicktochat';
import AdaChatLoader  from '../../../modules/clicktochat/Adachat';
import FeedbackRatingAEM from '../../../modules/feedbackAEM/FeedbackRatingAEM';
import { configuredAEMUrl, getPageUrl } from '../../../utils/AEMUtils';
import { miawChatCheckLocale } from '../../../utils';


const FooterContainer = ({ location, type }) => {
    const [onlineButtonId, setOnlineButtonId] = useState();
    const [offlineButtonId, setOfflineButtonId] = useState();
    const [reactiveButtonId, setReactiveButtonId] = useState();
    const [footerFeedbackDisplay, setFooterFeedbackDisplay] = useState(false);
    const dispatch = useDispatch();
    const { customerProfile, locale } = useSelector(state => state.CommonReducer);
    const userDetails = { ...customerProfile, memberId: customerProfile.subscriberId };
    const { REACT_APP_SERVICE_URL, REACT_PAGERULES, DATA_ENABLECACHING, MIAW_CHAT, AI_CHAT } = window.weeksWebCloudConfig;
    const url = configuredAEMUrl(getPageUrl('/content/panorama/rci/post-wow/@@Country/@@Lang/footer.model.json', locale));
    const feedbackUrl = `${localStorage.getItem("feedbackXfPath")}.model.json`;
    let dataMatch = ' ';
    if(DATA_ENABLECACHING){
    const localStoredData = JSON.parse(localStorage.getItem('_customerDetails'));
      if(JSON.stringify(localStoredData) !== JSON.stringify(userDetails)){
        dataMatch = false;   
      }
      else{
        dataMatch = true;  
      }
    }

    const setSalesforceParams = (onlineBtnId, offlineBtnId, reactiveBtnId) => {
        setOnlineButtonId(onlineBtnId);
        setOfflineButtonId(offlineBtnId);
        setReactiveButtonId(reactiveBtnId);
    };
    const closeFooterFeedback = (value) => {
        setFooterFeedbackDisplay(value);
    };
    const newChat = MIAW_CHAT && miawChatCheckLocale(locale);
    const isNewChatEnabled = AI_CHAT === true;
    React.useEffect(() => {
    // const chatHandler = ChatComponent({
    //   memberInfo: customerProfile,
    //   membershipDetails: customerProfile,
    //   setSalesforceParams,
    //   location,
    //   detailsAdded: true
    // });
        // if (typeof chatHandler === 'function' && !newChat) {
        //     if (window.liveagent && window.chatDeploymentJSLoaded) {
        //         chatHandler(customerProfile, customerProfile, setSalesforceParams, location, true);
        //     } else {
        //         const script = document.createElement('script');
        //         script.type = 'text/javascript';
        //         script.async = true;
        //         // script.src = 'https://c.la2-c1-ia2.salesforceliveagent.com/content/g/js/50.0/deployment.js';
        //         // ********************DEV Testing changes***************
        //         script.src = 'https://c.la1-c1cs-ord.salesforceliveagent.com/content/g/js/49.0/deployment.js';
        //         // ********************DEV Testing changes end***************
        //         script.addEventListener('load', () => {
        //             window.chatDeploymentJSLoaded = true;
        //             delay(() => chatHandler(customerProfile, customerProfile, setSalesforceParams, location), 500);
        //         }, false);
        //         const head = document.getElementsByTagName('head')[0];
        //         head.appendChild(script);
        //     }
        // }
    }, [newChat]);
    React.useEffect(() => {
        if (localStorage.getItem("feedbackXfPath")) {
            dispatch(fetchFeedbackContent(feedbackUrl));
        }

    }, [localStorage.getItem("feedbackXfPath")])
    return (
        <div id="footer-aem-container">
            <custom-postrci-footer
                isReact
                // data-slimfooter="show"
                showfooterlinks
                data-displaycacheddata={dataMatch}
                data-enablecaching={DATA_ENABLECACHING}
                data-userdetails={JSON.stringify(userDetails)}
                searchpagerendered={false}
                data-envdomain={REACT_APP_SERVICE_URL}
                data-applicationtype="WOW"
                data-url={url}
                data-apiurl={REACT_PAGERULES}
                footer-chat-id={`footer_${onlineButtonId}`}
            />
            <FeedbackAEM onlineButtonId={onlineButtonId} offlineButtonId={offlineButtonId} reactiveButtonId={reactiveButtonId} footerType={type} />
            {(footerFeedbackDisplay) && (<FeedbackRatingAEM closeFeedBack={closeFooterFeedback} />
            )}            
            {isNewChatEnabled && <AdaChatLoader />}
            {/* {newChat && <ChatComponent memberInfo={customerProfile} />} */}
            <ChatComponent memberInfo={customerProfile} />
        </div>);
}

FooterContainer.propTypes = {
    location: PropTypes.instanceOf(Object).isRequired,
    type: PropTypes.string,
};

FooterContainer.defaultProps = {
    type: '',
}


export default FooterContainer;